import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../guards/authguard/auth-guard';
import { SalesGuard } from '../../guards/salesguard/sales-guard.guard';
import { SalesInsightsDashboardComponent } from './components/sales-insights-dashboard/sales-insights-dashboard.component';
import { SalesInsightsModule } from './sales-insights.module';

const routes: Routes = [
  {
    path: ':id',
    component: SalesInsightsDashboardComponent,
    canActivate: [AuthGuard, SalesGuard]
  }
];

@NgModule({
  imports: [SalesInsightsModule, RouterModule.forChild(routes)]
})
export class SalesInsightsRoutingModule {}
